<!--
 * @des: 获取小程序URL Scheme
 * @Author: zhc
 * @Date: 2022-06-257 14:55:54
-->
<template>
  <div class="pages">
    <div v-if="!wxAndAlipayFlag" class="tips-box">
      <img src="../../assets/img/20241017-161801.png" alt="">
      <div class="tips-box-text">请打开支付宝扫一扫参与寄件优惠活动</div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { getScheme, getAppletParams } from '@/api'
export default {
  name: 'XcxSchemeLink',
  data() {
    return {
      COM_HTTP: getScheme,
      wxAndAlipayFlag: true,
    }
  },
  computed: {
    isWxEnv() {
      // 是否电脑微信或者微信开发者工具企业微信
      return /MicroMessenger/.test(window.navigator.userAgent)
    },
    isAliPayEnv() {
      return /AlipayClient/.test(window.navigator.userAgent)
    },
  },
  created() {},
  mounted() {
    // path默认寄件页
    const { path = 'pages/sendGoods/sendGoods', salesmanRandomCode = '' } = this.$route.query
    // 非移动端或者非微信、支付宝环境
    if (this.$equipment() === null || (!this.isWxEnv && !this.isAliPayEnv)) {
      // PC端执行
      this.wxAndAlipayFlag = false
    } else {
      this.wxAndAlipayFlag = true
      // 支付宝跳转
      if (this.isAliPayEnv) {
        const param = encodeURIComponent(`salesmanRandomCode=${salesmanRandomCode}`)
        const scheme = `alipays://platformapi/startapp?appId=2021003120640179&page=${path}&query=${param}`
        window.location.href = `https://ds.alipay.com/?scheme=${encodeURIComponent(scheme)}`
      } else if (this.isWxEnv) { // 微信跳转
        this.getScheme(path, salesmanRandomCode)
      }
    }
  },
  methods: {
    // 请求小程序链接
    async getScheme(path, salesmanRandomCode) {
      try {
        // path首个字符串不是/开头，则添加/
        if (!(path && path.startsWith('/'))) {
          path = '/' + path
        }
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        })
        const params = {
          path,
          queryParams: encodeURIComponent(`salesmanRandomCode=${salesmanRandomCode}`),
        }
        const { code, msg, data } = await this.COM_HTTP.getSchemeUrl2(params)
        this.$toast.clear()
        if (code === 1) {
          window.location.href = data // 页面重定向新的地址
          this.immediateCouponCollection()
        } else {
          alert(msg)
        }
      } catch (err) {
        console.log('🚀 ~ getScheme ~ err:', err)
        this.$toast.clear()
      }
    },
    // 使用微信js-sdk关闭当前h5页面
    async immediateCouponCollection () {
      const WX_LINK = window.location.href
      const { code, data } = await getAppletParams.getAppletParams(WX_LINK)
      if (code === 1) {
        wx.config({
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: ['closeWindow'],
        })
        // 通过ready接口处理成功验证
        wx.ready(function () {
          wx.closeWindow()
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">

.tips-box {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  img {
    width: 200px;
  }

  &-text {
    width: 150px;
    text-align: center;
    color: #a7a7a7;
    font-size: 16px;
    margin-top: 20px;
  }
}
</style>
